export enum SupportedClientCountryCode {
    ES = 'ES',
    UK = 'GB',
    US = 'US',
    TW = 'TW',
    CN = 'CN',
    JP = 'JP',
}
